import { Injectable, Injector } from '@angular/core';
import { Location } from '@angular/common';
import { AbstractNavigator } from '@auth0/auth0-angular';

/**
 * Defers Auth0's post-callback navigateByUrl to the next macrotask via setTimeout(0).
 * Without this, the call fires synchronously inside Angular 21's initial navigation pipeline
 * and aborts it via AbortSignal before it can complete.
 */
@Injectable()
export class DeferredNavigator extends AbstractNavigator {
  constructor(location: Location, injector: Injector) {
    super(location, injector);
  }

  override navigateByUrl(url: string): void {
    setTimeout(() => super.navigateByUrl(url), 0);
  }
}
